import PropTypes from 'prop-types';
import {useEffect, useState} from 'react';
import {Picture} from '../atoms/Picture';
import {Video} from '../atoms/Video';
import {BrokenImageIcon} from '../svg/BrokenImageIcon';

export const EventThumbnail = (props) => {
  const {
    eventId,
    alt = 'template design',
    loading = 'eager',
    className = null,
    width,
    height,
    renderedImageUrl = '',
    // biome-ignore lint/suspicious/noEmptyBlockStatements: Fix me!
    onLoad = () => {},
  } = props;

  const [hasMediaError, setHasMediaError] = useState(false);
  const [mediaType, setMediaType] = useState(null);
  const thumbnailWidth = width || 100;
  const thumbnailHeight = height || 136;

  const mediaUrl = renderedImageUrl ? renderedImageUrl : `/event/${eventId}/og-image`;

  // biome-ignore lint/correctness/useExhaustiveDependencies: Fix me!
  useEffect(() => {
    if (renderedImageUrl) {
      // If a renderedImageUrl is provided, we assume it's an image - event thumbnails are always static.
      setMediaType('image');
      return;
    }
    const img = new Image();

    img.onload = () => {
      setMediaType('image');
    };

    img.onerror = () => {
      setMediaType('video');
    };

    img.src = mediaUrl;

    return () => {
      img.onload = null;
      img.onerror = null;
    };
  }, [mediaUrl]);

  if (hasMediaError) {
    return <BrokenImageIcon />;
  }
  if (!mediaType) {
    return <span className="evt-spinner inline" />;
  }
  return mediaType === 'image' ? (
    <Picture
      srcSet={mediaUrl}
      alt={alt}
      loading={loading}
      className={className}
      width={thumbnailWidth}
      height={thumbnailHeight}
      onError={() => setHasMediaError(true)}
      onLoad={onLoad}
    />
  ) : (
    <Video
      src={mediaUrl}
      className={className}
      mimeType="video/mp4"
      width={thumbnailWidth}
      height={thumbnailHeight}
      onError={() => setHasMediaError(true)}
      onCanPlay={onLoad}
    />
  );
};
EventThumbnail.propTypes = {
  loading: PropTypes.oneOf(['lazy', 'eager']),
  eventId: PropTypes.string.isRequired,
  alt: PropTypes.string,
  className: PropTypes.string,
  renderedImageUrl: PropTypes.string,
  onLoad: PropTypes.func,
};
